import { db } from "@/firebaseConfig";

const stripeSkusCollection = db.collection("stripe_skus");

const saveStripeSku = async (id, data) => {
  stripeSkusCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("StripeSku successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateStripeSku = async (id, data) => {
  stripeSkusCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("StripeSku successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteStripeSku = async id => {
  stripeSkusCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("StripeSku successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getStripeSkuById = async id => {
  return stripeSkusCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getStripeSkuByProduct = async productId => {
  return stripeSkusCollection
    .where("product_id", "==", productId)
    .get()
    .then(querySnapshot => {
      return !querySnapshot.empty ? querySnapshot.docs[0].data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getStripeSkuByProductPriceAndName = async (productId, price, name) => {
  return stripeSkusCollection
    .where("product_id", "==", productId)
    .where("price", "==", price)
    .where("name", "==", name)
    .get()
    .then(querySnapshot => {
      return !querySnapshot.empty ? querySnapshot.docs[0].data().sku : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  stripeSkusCollection,
  saveStripeSku,
  updateStripeSku,
  deleteStripeSku,
  getStripeSkuById,
  getStripeSkuByProduct,
  getStripeSkuByProductPriceAndName
};
